import { withInstall } from "../utils/index.mjs";
import _Divider from "./Divider.mjs";
const Divider = withInstall(_Divider);
var stdin_default = Divider;
import { dividerProps } from "./Divider.mjs";
export {
  Divider,
  stdin_default as default,
  dividerProps
};
